import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProgressBarService {
  private requestCount = 0;
  private loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();

  startLoading() {
    if (this.requestCount === 0) {
      this.loadingSubject.next(true);
    }
    this.requestCount++;
  }

  stopLoading() {
    setTimeout(() => {
      this.requestCount--;
      if (this.requestCount === 0) {
        this.loadingSubject.next(false);
      }
    }, 100);
  }
}


